import { render, staticRenderFns } from "./AddPhone.vue?vue&type=template&id=ff4e95b8&scoped=true&"
import script from "./AddPhone.vue?vue&type=script&lang=js&"
export * from "./AddPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4e95b8",
  null
  
)

export default component.exports